import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";

import useTable from "../components/useTable";
// import Controls from "../components/controls/Controls";
//
import {
  TableBody,
  TableRow,
  TableCell,
  // InputAdornment
} from "@mui/material";
import axios from "axios";
import { Dimmer } from "../components/spinner";

const CatalogoProveedor = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const txtBuscador = useRef();
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [recordsd, setRecordsd] = useState([]);
  const [values, setValues] = useState({});
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);
  const headCells = [
    {
      id: "responsable",
      label: "CEDULA/RIF",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "razonsocial",
      label: "NOMBRE",
      width: "300px",
      textAlign: "left",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
    /*    { id: 'accion', label: '', width: '120px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
     */
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.responsable.includes(target.value) ||
              x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var idprov = recordsAfterPagingAndSorting()[index].idproveedor;
    var idcdprov = recordsAfterPagingAndSorting()[index].responsable;
    var nomb = recordsAfterPagingAndSorting()[index].razonsocial;
    var datos = [];
    datos.push({
      idprov,
      idcdprov,
      nomb,
    });
    setValues(datos);
  };
  const seleccionarLista = (index) => (event) => {
    blanquear();
    if (props.imp === 1) {
      props.onHideAceptaCatProv(values[0].idprov);
    } else {
      props.onHideAceptaCatProv(
        values[0].idprov,
        values[0].idcdprov,
        values[0].nomb,
      );
    }
  };
  const seleccionarProveedor = () => {
    let endpoint = `${op.conexion}/api/catalogo/proveedor?tipo=${props.tipo}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var cord = [];
          for (let i = 0; i < response.data.length; i++) {
            cord.push({
              idproveedor: response.data[i].idproveedor,
              razonsocial: response.data[i].razonsocial,
              responsable: response.data[i].responsable,
            });
          }
          setRecords(cord);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setRecordsd([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatProv();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      onShow={() => {
        seleccionarProveedor();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Seleccionar Proveedor.</h3>
        <a type="button" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
          <input
            ref={txtBuscador}
            type="text"
            onChange={handleSearch}
            className="form-control search-input form-control-sm rounded-pill"
            placeholder="Buscar Proveedor..."
          />
        </div>
        <div className="col-12 p-0 m-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idproveedor}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "150px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.responsable}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.razonsocial}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill col-md-2"
          disabled={activo}
          onClick={seleccionarLista()}
        >
          Aceptar <i className="fas fa-check-circle"> </i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill text-light col-md-2"
        >
          Cancelar <i className="fas fa-window-close"> </i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default CatalogoProveedor;
